import {
  createContext,
  type Dispatch,
  type SetStateAction,
  use,
  useCallback,
} from 'react'

export const ModalContext = createContext<
  Dispatch<SetStateAction<boolean>> | ((open: boolean) => void)
>(() => undefined)

export function useCloseModal() {
  const setOpen = use(ModalContext)
  return useCallback(() => setOpen(false), [setOpen])
}
